import { useLightMode } from '@/hooks/useLightMode'

import { BadgeCounter, Box, Skeleton } from '@hivewatch/dark'

import { useGlobalUnresolvedIncidentsCountQuery } from '@/graphql/generated/hooks'

const INCIDENTS_COUNT_POLL_INTERVAL = 60_000

export const IncidentsCount = () => {
  const colorScheme = useLightMode()
  const { data: totalCountData, loading: isLoading } =
    useGlobalUnresolvedIncidentsCountQuery({
      pollInterval: INCIDENTS_COUNT_POLL_INTERVAL,
    })
  const totalCount = totalCountData?.globalUnresolvedIncidentsCount?.totalCount

  return isLoading ? (
    <Skeleton borderRadius='8px' height='22px' width='24px' />
  ) : (
    <Box
      as='span'
      data-testid='notificationsTab_activeIncidents_countBadge'
      display='inline-flex'
    >
      <BadgeCounter
        colorScheme={colorScheme}
        count={totalCount}
        // Active-incident totals are shown in full up to 99999, then "99999+".
        maxCount={99999}
        variant='incident'
      />
    </Box>
  )
}
